const { NODE_ENV } = process.env

let PAGE_CONFIG
const DEFAULT_OPTIONS = {
    config: {},
    path: "",
}
const URL_PREFIX = "https://cdn.vip-wifi.com/fangchan/config/pages"
export const getConfig = (options = DEFAULT_OPTIONS) => {
    const { config, path} = Object.assign({}, DEFAULT_OPTIONS, options)
    return new Promise((resovle) => {
        if (NODE_ENV !== 'production' || PAGE_CONFIG ) {
            PAGE_CONFIG = config
            resovle(config)
        } else {
            wx.request({
                url: `${URL_PREFIX}${path}`,
                data: {
                    v: new Date().getTime()
                },
                success: (res) => {
                    console.error('load config success', res)
                    if (res.statusCode === 200) {
                        PAGE_CONFIG = res.data
                        resovle(res.data)
                    } else {
                        PAGE_CONFIG = config
                        resovle(config)
                    }
                },
                fail () {
                    PAGE_CONFIG = config
                    resovle(config)
                }
            })
        }
    })
}